import { useEffect, useState } from "react";
import Shell from "../components/Shell.jsx";
import { api } from "../lib/api.js";

const ENTITY_LABEL = {
  transaction: "💵 Ledger",
  receipt: "🧾 Receipt",
  contact: "👤 Contact",
  deal: "🤝 Engagement",
  task: "✅ Task",
  trip: "🚗 Trip",
  invoice: "📄 Invoice",
  bank_txn: "🏦 Bank line",
  bank_import: "🏦 Import",
  stripe_txn: "💳 Stripe",
};

// Read-only viewer over the append-only change_log: who changed what, when.
export default function AuditLog() {
  const [entries, setEntries] = useState([]);
  const [entities, setEntities] = useState([]);
  const [entity, setEntity] = useState("");
  const [offset, setOffset] = useState(0);
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(true);

  async function load(reset = false, filterEntity = entity) {
    setLoading(true);
    const off = reset ? 0 : offset;
    const d = await api(`/api/audit?limit=50&offset=${off}${filterEntity ? `&entity=${encodeURIComponent(filterEntity)}` : ""}`).catch(() => ({ entries: [], entities: [] }));
    setEntries((prev) => (reset ? d.entries : [...prev, ...d.entries]));
    if (d.entities?.length) setEntities(d.entities);
    setOffset(off + (d.entries?.length || 0));
    setDone((d.entries?.length || 0) < 50);
    setLoading(false);
  }
  useEffect(() => {
    load(true);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function pick(e) {
    setEntity(e);
    setOffset(0);
    load(true, e);
  }

  return (
    <Shell title="Activity log" back>
      <div className="flex flex-wrap gap-1.5">
        <button onClick={() => pick("")} className={`rounded-full px-3 py-1.5 text-xs font-semibold ${entity === "" ? "bg-navy-700 text-white" : "bg-white text-slate-600 shadow-sm"}`}>
          All
        </button>
        {entities.map((e) => (
          <button key={e} onClick={() => pick(e)} className={`rounded-full px-3 py-1.5 text-xs font-semibold ${entity === e ? "bg-navy-700 text-white" : "bg-white text-slate-600 shadow-sm"}`}>
            {ENTITY_LABEL[e] || e}
          </button>
        ))}
      </div>

      <div className="divide-y divide-slate-100 rounded-2xl bg-white shadow-sm">
        {entries.map((e) => (
          <div key={e.id} className="px-4 py-3">
            <p className="text-sm text-slate-800">
              <span className="font-medium">{e.user_name || "System"}</span> · {e.action} · {ENTITY_LABEL[e.entity] || e.entity}
            </p>
            <p className="text-xs text-slate-400">
              {e.at} UTC
              {e.detail ? ` · ${e.detail.slice(0, 120)}` : ""}
            </p>
          </div>
        ))}
        {entries.length === 0 && !loading && <p className="px-4 py-6 text-center text-sm text-slate-400">Nothing logged yet.</p>}
      </div>

      {!done && (
        <button onClick={() => load(false)} disabled={loading} className="w-full rounded-xl border border-slate-300 py-3 text-sm font-semibold text-slate-500 disabled:opacity-50">
          {loading ? "Loading…" : "Load more"}
        </button>
      )}
    </Shell>
  );
}
